import { useIntl } from 'react-intl'

import { type SupportRequesterStatus } from '@onr/schema'

import { Badge, type BadgeProps } from '@/components/atoms/Badge/Badge.tsx'
import { cn } from '@/lib/utils.ts'

const VARIANT_BY_REQUESTER_STATUS = {
  open: 'blueLight',
  waitingRequester: 'orange',
  settled: 'greenLight',
} as const satisfies Record<SupportRequesterStatus, BadgeProps['variant']>

export interface SupportStatusPillProps {
  readonly status: SupportRequesterStatus
  readonly className?: string
}

export const SupportStatusPill = ({ status, className }: SupportStatusPillProps) => {
  const intl = useIntl()
  return (
    <Badge
      variant={VARIANT_BY_REQUESTER_STATUS[status]}
      className={cn('w-auto shrink-0 pt-1 pb-[3px] text-sm', className)}>
      {intl.formatMessage({ id: `soutien.requesterStatus.${status}` })}
    </Badge>
  )
}
